import * as Api from '@ViewModels';

export const STAR_RATING_LIMIT = 5;

export const DEFAULT_MINIMUM_STAR_RATING = 4;

export const DEFAULT_MINIMUM_CONFIDENCE = 90;

export const AUTO_REPLY_MODE_OPTIONS: { label: string; mode: Api.GoogleReviewAutoReplyMode }[] = [
	{ label: `Off: I'll approve every AI reply before it posts`, mode: Api.GoogleReviewAutoReplyMode.Off },
	{ label: 'Auto-reply to reviews at or above a star rating', mode: Api.GoogleReviewAutoReplyMode.StarThreshold },
	{ label: `Let AI decide when it's safe to reply automatically`, mode: Api.GoogleReviewAutoReplyMode.AIDiscretion },
];

export const AUTO_REPLY_CAUTION_LEVELS: { label: string; description: string; minimumConfidence: number }[] = [
	{ description: 'Only reply automatically when AI is very confident.', label: 'Conservative', minimumConfidence: 90 },
	{ description: 'Reply automatically to routine reviews.', label: 'Standard', minimumConfidence: 75 },
	{ description: 'Reply automatically unless AI spots a real concern.', label: 'Relaxed', minimumConfidence: 50 },
];

export const STAR_THRESHOLD_OPTIONS = Array.from({ length: STAR_RATING_LIMIT }).map((_, i) => {
	const count = STAR_RATING_LIMIT - i;
	return { label: count === STAR_RATING_LIMIT ? `${count} stars only` : `${count}+ stars`, value: String(count) };
});

// Equality follows the server's semantics: only the threshold relevant to the mode matters, because the
// API nulls the others on save.
export const autoReplySettingsEqual = (
	a?: Api.IGoogleReviewAutoReplySettings,
	b?: Api.IGoogleReviewAutoReplySettings
) => {
	const modeOf = (s?: Api.IGoogleReviewAutoReplySettings) => s?.mode ?? Api.GoogleReviewAutoReplyMode.Off;
	if (modeOf(a) !== modeOf(b)) {
		return false;
	}
	if (modeOf(a) === Api.GoogleReviewAutoReplyMode.StarThreshold) {
		return (a?.minimumStarRating ?? null) === (b?.minimumStarRating ?? null);
	}
	if (modeOf(a) === Api.GoogleReviewAutoReplyMode.AIDiscretion) {
		return (a?.minimumConfidence ?? null) === (b?.minimumConfidence ?? null);
	}
	return true;
};
